import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)
import axios from 'axios'
import Conf from '../../router/Conf'
import { S4 } from "@/utils/common.js";

export const USER_SIGNIN = 'USER_SIGNIN' // 登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录
export const SYSTEM_INIT = 'SYSTEM_INIT' // 系统初始化 
export const SHOW_LOADDING = 'SHOW_LOADDING' // 显示加载状态
export const HIDE_LOADDING = 'HIDE_LOADDING' // 隐藏加载状态
export const SET_HISTOR = 'SET_HISTOR' //返回跳转页面
export const SET_ACTIVE = 'SET_ACTIVE'
export default {
	state: {
		'rndid':'fd_'+(new Date().getTime())+"_"+S4()+"_"+S4(),
		'user': {},
		'token': localStorage.getItem('token') || '',
		'logined': false, // 是否登录
		'loading': true, // 加载状态
		'android': '', // 安卓下载地址
		'datetime': '', // 服务器时间
		'ios': '', // 苹果下载地址
		'service': '', // 在线客服
		'histor': false,
	},
	mutations: {
		[USER_SIGNIN](state, user) {
			state.user = user
			state.logined = Boolean(user)
			localStorage.setItem('logined', Boolean(user))
			if (user.token) {
				localStorage.setItem('token', user.token)
			}
		},
		[USER_SIGNOUT](state) {
			state.user = {}
			state.logined = false
			localStorage.removeItem('logined')
			localStorage.removeItem('token')
		},
		[SYSTEM_INIT](state, data) {
			for (var key in data) {
				state[key] = data[key]
			}
		},
		[SHOW_LOADDING](state) {
			state.loading = true
		},
		[HIDE_LOADDING](state) {
			state.loading = false
		},
		[SET_HISTOR](state, data) {
			state.histor = data
		},
  
	},
	actions: {
		[USER_SIGNIN]({
		commit
		}, user) {
			commit(USER_SIGNIN, user)
		},
		[SYSTEM_INIT]({commit}){
			var initfun = async function(){
				await axios.get(Conf.serverUrl+"Common/info")
				.then(response => {
					commit(SYSTEM_INIT, response.data);
					if(response.data.ws){
						let ws = response.data.ws;
						let wssed = Conf.serverPre.indexOf("https://") > -1;
						wssed = wssed || window.location.protocol == "https:";
						let websocketUrl = wssed ? "wss://" : "ws://";
						websocketUrl += ws.ws_host;
						websocketUrl += wssed
						? (ws.web_port && !(ws.web_port == 80 || ws.web_port == 443)
							? ":" + ws.web_port
							: "") + "/wss/"
						: ":" + ws.ws_port;
						localStorage.setItem("ws_url", websocketUrl);
					}
					/**
					localStorage.removeItem("common_info");
					localStorage.setItem("common_info", JSON.stringify(response.data));
					if(response.data.ws){
						localStorage.setItem("ws", JSON.stringify(response.data.ws));
						//this.websocket.compWsUrl(this.Conf.serverPre);
					}
					*/
				})
				.catch(error => {});
			}
			initfun();
		}
	}

}


// WEBPACK FOOTER //
// ./src/store/modules/user.js